<template>
    <div>
        <table-page
            :client="client"
            @updated="getEarnings"
            :warnings="warnings"
            :changelogs="changelogs"
            :hideTabs="true"
        >
            <fast-table
                :recordLabel="recordLabel"
                :sections="sections"
                :headers="headers"
                :data="tableData"
                :activeRowId="currentEarningId"
                @click="currentEarningId = $event.id"
            >
                <template v-slot:table-actions>
                    <button class="btn btn-primary btn-collapse mr-1" id="addEarningTypeButton" @click="addEarningTypeModalOpen = true">
                        <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Earning Type</span>
                    </button>
                </template>
            </fast-table>

            <add-earning-type-modal
                v-if="addEarningTypeModalOpen"
                :client="client"
                @updated="getEarnings"
                @close="addEarningTypeModalOpen = false"
                :earning-id-company-ids="earningIdCompanyIds"
            />
        </table-page>

        <earning-sidebar
            v-if="currentEarning"
            :client="client"
            :earning-id="currentEarning.id"
            ref="earningSidebar"
            @updated="getEarnings"
            @close="currentEarningId = null"
        >
        </earning-sidebar>
    </div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import EarningSidebar from './components/Earnings/EarningSidebar'
import AddEarningTypeModal from './components/Earnings/AddEarningModal'

export default {
    components: {FastTable, EarningSidebar, AddEarningTypeModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        currentEarning() {
            return this.earnings.find(e => (e.id == this.currentEarningId))
        },
        sections() {
            let sections = [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Inactive', defaultIsClosed: true, id: 'inactive', hasDateFilter: true},
            ]
            return sections
        },
        activeEarnings() {
            return this.earnings.filter((p) => {return p.is_active})
        },
        inactiveEarnings() {
            return this.earnings.filter((p) => {return !p.is_active})
        },
        tableData() {
            const tableData = []
            const subsets = [
                this.activeEarnings,
                this.inactiveEarnings,
            ]

            subsets.forEach(earnings => {
                const sectionData = []

                earnings.forEach(earning => {
                    sectionData.push({
                        id: earning.id,
                        object: earning,
                        cells: this.makeEarningTableData(earning),
                    })
                })
                tableData.push(sectionData)
            })
            return tableData
        },
        earningIdCompanyIds() {
            // Used to show which earning types already exist in which company when adding new ones
            const result = {}
            this.earnings.forEach(e => {
                if (e.earning_type.allow_multiple_per_company) {return}
                result[e.earning_type_id] = result[e.earning_type_id] || []
                result[e.earning_type_id].push(e.company_id)
            })

            return result
        },
    },
    data() {
        return {
            earnings: [],
            dataLoaded: false,
            currentEarningId: null,
            recordLabel: "Earnings",
            headers: [
                {label: 'Company', classes: 'cell-company', isFilterable: true, isSearchable: true, defaultSort: true},
                {label: 'Earning Name', classes: 'cw-18', isSearchable: true, isFilterable: false},
                {label: 'System Earning Type', classes: 'cw-18', isSearchable: true, isFilterable: true},
                {label: 'Type', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Positions', classes: '', isSearchable: false},
                // {label: 'Status', classes: '', isSearchable: false, isFilterable: true},
            ],
            addEarningModalOpen: false,
            addEarningTypeModalOpen: false,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Earnings')
        this.getEarnings()
    },
    methods: {
        getEarnings() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/earning-types`).then(resp => {
                this.earnings = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
        makeEarningTableData(earning) {
            return [
                earning.company.name,
                earning.name,
                earning.earning_type.name,
                earning.type_pretty,
                earning.num_positions,
                // earning.is_active ? 'Active' : 'Inactive'
            ]
        },
        openAddEarningModal() {
            this.addEarningModalOpen = true
        }
    },
}
</script>
